<template>
  <div class="top-gold-companies p-3">
    <h4>Gold companies in FinCEN Files</h4>
    <p class="mb-0">The total amount of transactions from 2007 to 2016 reported in suspicious activity reports, filed by banks in FinCEN Files.</p>
    <stacked-bar-chart :data="data" x-axis-tick-format="$," label-above hide-legend :social-mode="socialMode" :fixed-height="height" />
    <p class="text-muted mt-2 small text-right">
      Source: FinCEN Files
    </p>
    <p class="mt-2 font-italic">This data is not representative of all SARs received by the U.S. Department of Treasury's Financial Crimes Enforcement Network. Data for Kaloti Jewellery Group covers Aug. 2007 to June 2015; Metalor Jun. 2012 to Oct. 2016; and Argor Heraeus Mar. 2014 to June 2015.</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  name: 'TopGoldCompanies',
  mixins: [chart],
  data () {
    return {
      data: [
        { label: 'Kaloti Jewellery Group', value: 9322281853 },
        { label: 'Metalor Technologies International SA', value: 2645172857 },
        { label: 'Argor Heraeus', value: 17597358 }
      ]
    }
  }
}
</script>
